module.exports = __webpack_public_path__ + "img/image_26.f481db0c.png";